import { fetchIpAndUserAgent } from '~/utils/checkout/fetch-ip-and-user-agent';
import { TokenizedPaymentCard } from '~/interfaces/payment';
import { Address } from '~/interfaces/commerce-types';
import {
  FORTER_TOKEN,
  FORTER_TOKEN_LOCALSTORAGE_KEY,
} from '~/constant/cookies';
import { getDocCookie } from '~/utils/doc-cookies';
import { TYPES } from '~/modules/payment/constants';

interface IOnlinePayCheckoutSettings {
  tokenizedCard: TokenizedPaymentCard;
  isForterValidationEnabled: boolean;
  billingAddress: Address;
  userSelectedAmount: number;
  paymentOption: string;
  affirmPromoValue?: string;
  isForterValidationEnabledForAdyen?: boolean;
}

interface ExtensionProperty {
  Key: string;
  Value: { StringValue?: string; BooleanValue?: boolean };
}

export const getRetrieveCardPaymentSettings = (
  PaymentConnectorId: string,
  cartId: string,
  authCode: string,
  returnUrl?: string,
) => {
  return {
    resultAccessCode: authCode,
    extensionProperties: [],
    cartId,
    settings: {
      ReturnUrl: returnUrl || '/checkout?pv=1',
      PaymentConnectorId,
    },
  };
};

export async function onlinePayCheckoutSettings({
  tokenizedCard,
  isForterValidationEnabled,
  billingAddress,
  userSelectedAmount,
  paymentOption,
  affirmPromoValue,
  isForterValidationEnabledForAdyen,
}: IOnlinePayCheckoutSettings) {
  let forterToken: string | undefined =
    localStorage?.getItem(FORTER_TOKEN_LOCALSTORAGE_KEY) || undefined;
  if (!forterToken) {
    forterToken = getDocCookie(FORTER_TOKEN);
    localStorage?.setItem(FORTER_TOKEN_LOCALSTORAGE_KEY, forterToken ?? '');
  }
  const { clientIp, userAgent } = await fetchIpAndUserAgent();
  userSelectedAmount = Math.round(userSelectedAmount * 100) / 100;
  const updatedExtensions: ExtensionProperty[] = [];
  const isCreditCardPayment =
    paymentOption?.toLowerCase() === TYPES.CREDIT_CARD.toLowerCase() ||
    paymentOption?.toLowerCase() === TYPES.ADYEN.toLowerCase();
  if (isCreditCardPayment) {
    const isAdyenPaymentOption =
      paymentOption?.toLowerCase() === TYPES.ADYEN.toLowerCase();
    const forterValidationEnabled = isAdyenPaymentOption
      ? (isForterValidationEnabledForAdyen ?? false)
      : isForterValidationEnabled;
    updatedExtensions.push(
      { Key: 'clientIPAddress', Value: { StringValue: clientIp } },
      { Key: 'userAgent', Value: { StringValue: userAgent } },
      { Key: 'forterToken', Value: { StringValue: forterToken } },
      {
        Key: 'isForterValidationEnabled',
        Value: { BooleanValue: forterValidationEnabled },
      },
    );
  }

  if (
    tokenizedCard?.CardTypeId?.toLowerCase() === TYPES.PROGRESIVE.toLowerCase()
  ) {
    updatedExtensions?.push({
      Key: 'PromoCode',
      Value: {
        StringValue: 'PRO',
      },
    });
  }
  if (affirmPromoValue) {
    updatedExtensions?.push({
      Key: 'PromoCode',
      Value: {
        StringValue: affirmPromoValue,
      },
    });
  }
  return [
    {
      '@odata.type':
        '#Microsoft.Dynamics.Commerce.Runtime.DataModel.CartTenderLine',
      'Amount@odata.type': '#Decimal',
      Currency: 'USD',
      Amount: userSelectedAmount,
      TenderTypeId: tokenizedCard?.TenderType,
      CardTypeId: tokenizedCard?.CardTypeId,
      TokenizedPaymentCard: {
        ...tokenizedCard,
        ...(billingAddress && {
          NameOnCard: billingAddress.Name || 'N/A',
          House: tokenizedCard.House || 'N/A',
          Phone: billingAddress.Phone,
          Country: billingAddress.ThreeLetterISORegionName,
          Address1: billingAddress.Street,
          City: billingAddress.City,
          State: billingAddress.State,
          Zip: billingAddress.ZipCode,
        }),
      },
      ExtensionProperties: updatedExtensions,
    },
  ];
}
